export const CACHE_KEY_LOCALE = "locale";
export const CACHE_KEY_NAME = "name";
export const CACHE_KEY_SERVICE_OPTION_NAME = "serviceOptionName";
export const CACHE_KEY_DELIVERY_CONTACT = "deliveryContact";
export const CACHE_KEY_CUSTOMER_FIELDS = "customerFields";
export const CACHE_KEY_VOUCHER_CODES = "voucherCodes";
export const CACHE_KEY_STARNET_CARD = "starnetCard";
export const CACHE_KEY_ORDER_HISTORY = "orderHistory";
